import React from "react";
import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";

interface BackButtonProps {
  variant?: "overlay" | "surface";
  fallbackTo?: string;
  className?: string;
  reverseOnMobile?: boolean;
  reverseArrow?: boolean;
}

const BackButton: React.FC<BackButtonProps> = ({
  variant = "surface",
  fallbackTo = "/",
  className = "",
  reverseOnMobile = false,
  reverseArrow = false,
}) => {
  const navigate = useNavigate();

  const handleBack = () => {
    if (window.history.length > 1) {
      navigate(-1);
      return;
    }

    navigate(fallbackTo);
  };

  const variantClass = variant === "overlay"
    ? "border-white/40 bg-white/20 text-white shadow-md backdrop-blur-md hover:bg-white/30 focus-visible:ring-white focus-visible:ring-offset-black/40"
    : "border-gray-200 bg-white text-gray-700 hover:bg-gray-50 focus-visible:ring-[#038545] focus-visible:ring-offset-white";

  return (
    <button
      type="button"
      onClick={handleBack}
      aria-label="بازگشت"
      title="بازگشت"
      className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-lg border transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 ${variantClass} ${className}`}
    >
      <ArrowLeft
        size={19}
        strokeWidth={2}
        className={
          reverseArrow
            ? "rotate-180"
            : reverseOnMobile
              ? "rotate-180 tablet:rotate-0"
              : ""
        }
        aria-hidden="true"
      />
    </button>
  );
};

export default BackButton;
